var React = require('react');

function PhoneOutline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"stroke":"currentColor","strokeWidth":"10","x":"5","y":"5","width":"444","height":"210","rx":"30","key":0}),React.createElement("rect",{"fill":"currentColor","x":"24","y":"80","width":"20","height":"60","rx":"10","key":1})]));
}

PhoneOutline.defaultProps = {"width":"454px","height":"220px","viewBox":"0 0 454 220","version":"1.1"};

module.exports = PhoneOutline;

PhoneOutline.default = PhoneOutline;
